/**dashboard */
export const dashboardPath = `/dashboard`;

/**Admin users */
export const adminUserBasePath = `/admin_user`;
export const adminUserViewPath = `${adminUserBasePath}/view`;
export const adminUserCreatePath = `${adminUserBasePath}/create`;
export const adminUserEditPath = ({ id }) => `${adminUserBasePath}/edit/${id}`;

/**client portal setup route-paths */
/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
export const clientPortalSetupBasePath = `/client_portal_setup`;
/**All Client Accounts */
export const accountBasePath = `${clientPortalSetupBasePath}/accounts`;
/**client Account paths */
export const clientAccountBasePath = `${accountBasePath}/client_acc`;
export const clientAccountViewPath = `${clientAccountBasePath}/view`;
export const clientAccountCreatePath = `${clientAccountBasePath}/create`;
export const clientAccountEditPath = ({ id }) =>
  `${clientAccountBasePath}/edit/${id}`;

/**client sub-Account paths */
export const clientSubAccountBasePath = `${accountBasePath}/client_sub_acc`;
export const clientSubAccountViewPath = `${clientSubAccountBasePath}/view`;
export const clientSubAccountCreatePath = `${clientSubAccountBasePath}/create`;
export const clientSubAccountEditPath = ({ id }) =>
  `${clientSubAccountBasePath}/edit/${id}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
/**All Report and Resources */
export const reportBasePath = `${clientPortalSetupBasePath}/reports`;
{
  /**client_specific_report */
}
export const clientSpecificReportBasePath = `${reportBasePath}/client_specific_report`;
export const clientSpecificReportViewPath = `${clientSpecificReportBasePath}/view`;
export const clientSpecificReportCreatePath = `${clientSpecificReportBasePath}/create`;
export const clientSpecificReportEditPath = ({ id }) =>
  `${clientSpecificReportBasePath}/edit/${id}`;

{
  /**thought_leadership_resources */
}
export const thoughtLeadershipResourceBasePath = `${reportBasePath}/thought_leadership_resources`;
export const thoughtLeadershipResourceViewPath = `${thoughtLeadershipResourceBasePath}/view`;
export const thoughtLeadershipResourceCreatePath = `${thoughtLeadershipResourceBasePath}/create`;
export const thoughtLeadershipResourceEditPath = ({ sitecoreId }) =>
  `${thoughtLeadershipResourceBasePath}/edit/${sitecoreId}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
/**All Programme descriptors */
export const programmeDescriptorBasePath = `${clientPortalSetupBasePath}/programme_descriptor`;
/** manage Programme descriptors */
export const managePDBasePath = `${programmeDescriptorBasePath}/manage_acc_pd`;
export const managePDViewPath = `${managePDBasePath}/view`;
export const managePDCreatePath = `${managePDBasePath}/create`;
export const managePDRecyclePath = `${managePDBasePath}/recycle`;
export const managePDEditPath = ({ id }) => `${managePDBasePath}/edit/${id}`;

/** client Account Programme descriptors */
export const clientAccPDBasePath = `${programmeDescriptorBasePath}/client_acc_pd`;
export const clientAccPDViewPath = `${clientAccPDBasePath}/view`;
export const clientAccPDCreatePath = `${clientAccPDBasePath}/create`;
export const clientAccPDEditPath = ({ id }) =>
  `${clientAccPDBasePath}/edit/${id}`;

/**adding custom resources for specific cilent account ID */
export const addCustomResourceByClientAccountId = ({ clientAccountId }) =>
  `${clientAccPDBasePath}/addCustomResource/${clientAccountId}`;

/**for folder actions */
export const managePDFolderViewPath = `${clientAccPDBasePath}/folder/view`;
export const viewFolderStructureForPD = ({ id }) =>
  `${clientAccPDBasePath}/folder/view/${id}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
/**All Referrals */
export const referralBasePath = `${clientPortalSetupBasePath}/referrals`;
{
  /**assign referral reqs */
}
export const assignReferralBasePath = `${referralBasePath}/assign_referral_req`;
export const assignReferralViewPath = `${assignReferralBasePath}/view`;
export const assignReferralEditPath = ({ id }) =>
  `${assignReferralBasePath}/edit/${id}`;

{
  /**manage referral reqs */
}
export const manageReferralBasePath = `${referralBasePath}/manage_referral_req`;
export const manageReferralViewPath = `${manageReferralBasePath}/view`;
export const manageReferralCreatePath = `${manageReferralBasePath}/create`;
export const manageReferralEditPath = ({ id }) =>
  `${manageReferralBasePath}/edit/${id}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
{
  /** account team member */
}
export const accountTeamMemberBasePath = `${clientPortalSetupBasePath}/acc_team`;
export const accountTeamMemberViewPath = `${accountTeamMemberBasePath}/view`;
export const accountTeamMemberCreatePath = `${accountTeamMemberBasePath}/create`;
export const accountTeamMemberEditPath = ({ id }) =>
  `${accountTeamMemberBasePath}/edit/${id}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
{
  /** meeting requests */
}
export const meetingReqBasePath = `${clientPortalSetupBasePath}/meeting_requests`;
export const meetingReqViewPath = `${meetingReqBasePath}/view`;
export const meetingReqCreatePath = `${meetingReqBasePath}/create`;
export const meetingReqEditPath = ({ id }) =>
  `${meetingReqBasePath}/edit/${id}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
{
  /** admin messages */
}
export const adminMsgBasePath = `${clientPortalSetupBasePath}/admin_messages`;
export const adminMsgViewPath = `${adminMsgBasePath}/view`;
export const adminMsgCreatePath = `${adminMsgBasePath}/create`;
export const adminMsgEditPath = ({ id }) => `${adminMsgBasePath}/edit/${id}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
{
  /** client users */
}
export const clientUserBasePath = `${clientPortalSetupBasePath}/client_users`;
export const clientUserViewPath = `${clientUserBasePath}/view`;
export const clientUserCreatePath = `${clientUserBasePath}/create`;
export const clientUserEditPath = ({ id }) =>
  `${clientUserBasePath}/edit/${id}`;

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */

/** !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
